module.exports = __webpack_public_path__ + "img/close.87caecb2.png";